import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({
  name: 'orderBy',
  standalone: true,
})
export class OrderByPipe implements PipeTransform {
  transform(
    /* eslint-disable @typescript-eslint/no-explicit-any */
    array: any,
    sortBy: string,
    sortOrder: 'asc' | 'desc' = 'asc'
  ) {
    // setting default ascending order
    /* eslint-disable @typescript-eslint/no-explicit-any */
    return orderBy(array, [sortBy], [sortOrder]) as any;
  }
}
